module.exports = __webpack_public_path__ + "fonts/Barlow-ExtraLight.8fcfe8c5.woff";